import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";

export default function SelectCountryDialog({ formik, countryFieldName, cityFieldName, disabled }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const masterData = useSelector(selectMasterData);
  const countryConfig = get(masterData, "countryConfig", []);

  const handleClickOpen = () => {
    if (disabled) { return; }
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  const countryId = get(
    formik.values,
    countryFieldName,
    ""
  )
  const cityId = get(
    formik.values,
    cityFieldName,
    ""
  )

  const cityListById = get(
    countryConfig.filter(
      (country) =>
        country.countryId ===
        get(
          formik.values,
          countryFieldName,
          ""
        )
    ),
    "0.cityConfig",
    []
  )
  const countryText = countryConfig.find(v => v.countryId === countryId)
  const cityText = cityListById.find(v => v.cityID === cityId)

  return (
    <>
      <TextField
        disabled={disabled}
        variant="outlined"
        className={classes.textFieldWithDots}
        fullWidth
        inputProps={{
          fullWidth: true,
        }}
        onClick={handleClickOpen}
        placeholder="Country"
        value={`${countryText?.countryName || ''}${cityText ? ` / ${cityText?.cityName}` : ''}`}
      />
      <FormHelperText
        error={false}
      >
        {" "}
      </FormHelperText>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose} keepMounted={false}>
        <DialogTitle>Select Country / City</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // width: 250,
            }}
          >
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: 120 }}
              error={isError(
                countryFieldName,
                formik
              )}
            >
              <InputLabel>Country</InputLabel>
              <Select
                label="Country"
                name={countryFieldName}
                value={get(
                  formik.values,
                  countryFieldName,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                {countryConfig.map((country) => (
                  <MenuItem
                    value={country.countryId}
                    key={country.countryId}
                  >
                    {country.countryName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText
                error={isError(
                  countryFieldName,
                  formik
                )}
              >
                {getErrorMessage(
                  countryFieldName,
                  formik
                )}
              </FormHelperText>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: 120 }}
              error={isError(
                countryFieldName,
                formik
              )}
            >
              <InputLabel>City</InputLabel>
              <Select
                label="City"
                name={cityFieldName}
                value={get(
                  formik.values,
                  cityFieldName,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                {get(
                  countryConfig.filter(
                    (country) =>
                      country.countryId ===
                      get(
                        formik.values,
                        countryFieldName,
                        ""
                      )
                  ),
                  "0.cityConfig",
                  []
                ).map((country) => (
                  <MenuItem value={country.cityID} key={country.cityID}>
                    {country.cityName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText
                error={isError(
                  cityFieldName,
                  formik
                )}
              >
                {getErrorMessage(
                  cityFieldName,
                  formik
                )}
              </FormHelperText>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}